import React, { useState, useEffect, ChangeEvent } from "react"
import {
  Button,
  CardBody,
  IconButton,
  Input,
  Spinner,
  Typography,
} from "@material-tailwind/react"

import { CustomHeader } from "../../../components/headers/CustomHeader"
import { useHistory } from "react-router-dom"
import { PolicyDetails, Document } from "./policy_detaildummy"
import { BiEdit, BiPlus, BiTrash } from "react-icons/bi"
import { UserType } from "../../../types/user"
import { DEFAULTPRIMARYCOLOR } from "../../../util"
import { useQuery } from "@apollo/client"
import { POLICYSTICKERDETAILS } from "../../../GraphQl/queries"
import { BASEURL } from "../../../util"
import { toast } from "react-toastify"
import { useSelector } from "react-redux"
import { RootState } from "../../../store/store"
import { DriverModal } from "../../../components/modal/DriverModal"
import ErrorLog from "../../../components/error-logs"
import { useMutation } from "@apollo/client"
import { UPDATEDOCUMENT } from "../../../GraphQl/mutations"
import { error } from "console"

const PolicyDetail = () => {
  const [requestLoading, setRequestLoading] = useState(false)
  const [formData, setFormData] = useState<any | null>(null)
  const [loading, setLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [errors, setErrors] = useState<any | null>(null)


  const [stickerUrl, setStickerUrl] = useState("");



  const [updateDocuments, { loading: RequestLoading }] = useMutation(
    UPDATEDOCUMENT,
    {
      onCompleted: (data) => {
        toast.success("Document updated succesfully");
        setStickerUrl("");
        setShowModal(false);
      },
      onError: (error) =>
        toast.error(error?.message ?? "Document updated succesfully"),
    }
  )


  const handleSubmit = () => {

    const formattedSticker = `Sticker-${stickerUrl}.pdf`;
    const generatedstickerUrl = `https://v.nicmid.com/${stickerUrl}.pdf`;

    updateDocuments({
      variables: {
        id: localStorage.getItem("selected-policy-id"),
        name: formattedSticker,
        content: generatedstickerUrl
      },
    })
    // Close the modal after submission


  };



  const {
    companyId,
    roleId,
    usertype,
    user: stateUser,
    token,
  } = useSelector((state: RootState) => state.auth)

  const { data, loading: loadingPolicies } = useQuery<{
    policy: PolicyDetails[]
    documents: Document[]
  }>(POLICYSTICKERDETAILS, {
    variables: {
      id: localStorage.getItem("selected-policy-id"),
    },
  })



  // Update formData when data is fetched
  useEffect(() => {
    if (data) {


      // Extract the policy metadata
      if (data.policy.length > 0) {
        const { policy_sticker_creation_metadata } = data.policy[0]
        setFormData({ policy_sticker_creation_metadata })
      }

      // Extract and set error logs if documents exist
      if (data.documents.length > 0) {
        const { error_logs } = data.documents[0]
        console.log("Error Logs", error_logs)
        setErrors(error_logs)
      }
    }
  }, [data])




  const handleCreateSticker = async () => {

    try {
      setLoading(true)
      const payload = {
        policy_id: localStorage.getItem("selected-policy-id"),
        company_id: companyId,
        payload: formData?.policy_sticker_creation_metadata,
      }



      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/create_sticker_midv2`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      )

      const req = await response.json()

      if (response.ok) {
        toast.success("Sticker generated successfully")
      } else {
        toast.error(req?.msg)
      }
      setLoading(false)
    } catch (error) {
      toast.error("Error deleting admin")
      setLoading(false)
    }
  }

  const userData = localStorage.getItem("user")
  const [colors, setColors] = useState<string[]>()

  useEffect(() => {
    if (userData) {
      const data: UserType = JSON.parse(userData)

      setColors(data.colors)
    }
  }, [])

  type Section = "customerData" | "vehicle" | "root"
  const NUMBER_FIELDS = ["registrationYear", "engineCapacity", "seatingCapacity", "grossPremium"]


  const handleChange = (
  e: ChangeEvent<HTMLInputElement>,
  section: Section
) => {
  const { name, value } = e.target

  // Convert only when needed
  const parsedValue =
    NUMBER_FIELDS.includes(name) && value !== ""
      ? Number(value)
      : value

  setFormData((prev: any) => {
    const newData = { ...prev }

    const metadata =
      newData.policy_sticker_creation_metadata ??
      (newData.policy_sticker_creation_metadata = { data: {} })

    const data =
      metadata.data ?? (metadata.data = {})

    switch (section) {
      case "customerData":
        data.customerData = {
          ...(data.customerData || {}),
          [name]: parsedValue,
        }
        break

      case "vehicle":
        data.vehicles = data.vehicles?.length
          ? [{ ...data.vehicles[0], [name]: parsedValue }]
          : [{ [name]: parsedValue }]
        break

      case "root":
        data[name] = parsedValue
        break
    }

    return newData
  })
}





  return (
    <>
      {/* <DriverModal
        title="Enter Sticker"
        open={showModal}
        size="xs"
        onClose={() => setShowModal(false)}
      >
        <form className="border-2  rounded-md "
          onSubmit={(e) => {
            e.preventDefault(); 
            handleSubmit();
          }}
        >
          <div className="p-4">
           
            <input
              type="text"
              id="stickerUrl"
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              value={stickerUrl}
              onChange={(e) => setStickerUrl(e.target.value)}
              placeholder="Enter sticker number"
              required
            />
          </div>
          <div className="p-4">
            <button
              type="submit"
              className="w-full inline-flex justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {RequestLoading ? "Loading..." : "Submit"}
            </button>
          </div>
        </form>
      </DriverModal> */}

      <DriverModal
        title="Error Logs"
        open={showModal}
        size="sm"
        onClose={() => setShowModal(false)}
      >
        <div className="p-4 space-y-4 text-sm">

          <div className="flex justify-between">
            <span className="font-semibold text-gray-600">Status Code</span>
            <span className="text-red-600">{errors?.status_code}</span>
          </div>

          <div>
            <p className="font-semibold text-gray-600 mb-1">Message</p>
            <div className="bg-gray-100 p-2 rounded text-gray-800">
              {errors?.message}
            </div>
          </div>

          <div>
            <p className="font-semibold text-gray-600 mb-1">Errors</p>

            <div className="bg-red-50 border border-red-200 p-2 rounded space-y-2">
              {Array.isArray(errors?.errors) && errors.errors.length > 0 ? (
                errors.errors.map((err: any, index: number) => (
                  <div key={index} className="text-red-700">
                    <span className="font-semibold capitalize">
                      {err.type}:
                    </span>{" "}
                    {err.detail}
                  </div>
                ))
              ) : (
                <span className="text-gray-500 text-sm">
                  No detailed errors available
                </span>
              )}
            </div>
          </div>

        </div>
      </DriverModal>




      <div className="flex w-full justify-between items-center">
        <CustomHeader title="Manage Policy Informations" />
        <Button
          onClick={() => setShowModal(true)}
          size="sm"
          className="capitalize flex items-center flex-row items-centerfont-normal"
          style={{
            background:
              colors?.length! > 1
                ? `${colors![0]?.toLowerCase()}`
                : `${DEFAULTPRIMARYCOLOR}`,
          }}
        >
          {loading ? <Spinner className="w-4 h-4" /> : "Check error logs"}
        </Button>
      </div>
      <div className="w-full flex flex-col md:flex-row lg:flex-row gap-5">
        <div className=" rounded-lg overflow-y-scroll w-full  lg:w-3/4">
          <div className="w-full flex flex-col space-y-4">
            <div className="p-3 bg-white rounded-b-xl ">
              <Typography className="text-lg font-bold">
                Customer Information{" "}
              </Typography>
              <div className="grid grid-cols-2 gap-4 mt-4">
                {/* INDIVIDUAL CUSTOMER DETAILS */}

                <Input
                  size="lg"
                  label="Title"
                  name="title"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.title || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                <Input
                  size="lg"
                  label="Customer Type"
                  name="type"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.type || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />
                <Input
                  size="lg"
                  label="First Name"
                  name="firstName"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.firstName || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                <Input
                  size="lg"
                  label="Last Name"
                  name="lastName"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.lastName || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                <Input
                  size="lg"
                  label="Other Names"
                  name="otherNames"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.otherNames || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                <Input
                  size="lg"
                  label="Gender"
                  name="gender"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.gender || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                <Input
                  size="lg"
                  label="Email"
                  name="email"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.email || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                <Input
                  size="lg"
                  label="Phone Number"
                  name="phoneNumber"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.phoneNumber || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                <Input
                  size="lg"
                  label="Digital Address"
                  name="digitalAddress"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.digitalAddress || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                <Input
                  size="lg"
                  label="Residential Address"
                  name="residentialAddress"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.residentialAddress || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                <Input
                  size="lg"
                  label="Occupation"
                  name="occupation"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.occupation || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                <Input
                  size="lg"
                  label="Ghana Card Number"
                  name="ghanaCardNumber"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.ghanaCardNumber || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                <Input
                  size="lg"
                  label="Date of Birth"
                  name="dateOfBirth"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.customerData
                      ?.dateOfBirth || ""
                  }
                  onChange={(e) => handleChange(e, "customerData")}
                />

                {/* CORPORATE DETAILS */}
                {formData?.policy_sticker_creation_metadata?.data?.customerData
                  ?.corporate_details && (
                    <>
                      <Input
                        size="lg"
                        label="Company Name"
                        name="company_name"
                        value={
                          formData.policy_sticker_creation_metadata.data.customerData
                            .corporate_details?.company_name || ""
                        }
                        onChange={(e) => handleChange(e, "customerData")}
                      />

                      <Input
                        size="lg"
                        label="Company Phone"
                        name="company_phone"
                        value={
                          formData.policy_sticker_creation_metadata.data.customerData
                            .corporate_details?.company_phone || ""
                        }
                        onChange={(e) => handleChange(e, "customerData")}
                      />

                      <Input
                        size="lg"
                        label="Registered Address"
                        name="registered_address"
                        value={
                          formData.policy_sticker_creation_metadata.data.customerData
                            .corporate_details?.registered_address || ""
                        }
                        onChange={(e) => handleChange(e, "customerData")}
                      />

                      <Input
                        size="lg"
                        label="Business Sector"
                        name="industry"
                        value={
                          formData.policy_sticker_creation_metadata.data.customerData
                            .corporate_details?.industry || ""
                        }
                        onChange={(e) => handleChange(e, "customerData")}
                      />

                      <Input
                        size="lg"
                        label="Year Established"
                        name="registration_year"
                        value={
                          formData.policy_sticker_creation_metadata.data.customerData
                            .corporate_details?.registration_year || ""
                        }
                        onChange={(e) => handleChange(e, "customerData")}
                      />

                      <Input
                        size="lg"
                        label="TIN Number"
                        name="tin"
                        value={
                          formData.policy_sticker_creation_metadata.data.customerData
                            .corporate_details?.tin || ""
                        }
                        onChange={(e) => handleChange(e, "customerData")}
                      />
                    </>
                  )}
              </div>

            </div>

            <div className="p-3 bg-white rounded-xl">
              <Typography className="text-lg font-bold">
                Vehicle Information
              </Typography>

              <div className="grid grid-cols-2 gap-4 mt-4">

                <Input
                  label="Vehicle Registration Number"
                  name="registrationNumber"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.registrationNumber || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Vehicle Make"
                  name="make"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.make || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Vehicle Model"
                  name="model"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.model || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Manufacture Year"
                  name="manufacturingYear"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.manufacturingYear || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Registration Year"
                  type="number"
                  name="registrationYear"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.registrationYear || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Chassis Number"
                  name="chassisNumber"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.chassisNumber || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Vehicle Colour"
                  name="vehicleColour"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.vehicleColour || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Body Type"
                  name="bodyType"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.bodyType || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Seating Capacity"
                  name="seatingCapacity"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.seatingCapacity || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Cubic Capacity"
                  name="cubicCapacity"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.cubicCapacity || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Sum Insured"
                  name="sumInsured"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.sumInsured || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />



                <Input
                  label="Gross Premium"
                  name="grossPremium"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.grossPremium || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />



                <Input
                  label="Risk Type Code"
                  name="riskTypeCode"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.riskTypeCode || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Type of Business"
                  name="type"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.type || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Product Type Code"
                  name="productCode"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.productCode || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Vehicle Value"
                  name="vehicleValue"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.vehicleValue || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Extra TPPD Charge"
                  name="extraTppdl"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.extraTppdl || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

                <Input
                  label="Fleet Discount"
                  name="fleetDiscount"
                  value={
                    formData?.policy_sticker_creation_metadata?.data?.vehicles?.[0]
                      ?.fleetDiscount || ""
                  }
                  onChange={(e) => handleChange(e, "vehicle")}
                />

              </div>
            </div>

          </div>
        </div>

        <div className="p-3 bg-white rounded-xl w-full">
          <Typography className="text-lg font-bold">
            Policy Details
          </Typography>

          <div className="grid grid-cols-2 gap-4 gap-x mt-4">

            <Input
              label="Branch Code"
              name="branchCode"
              value={
                formData?.policy_sticker_creation_metadata?.data?.branchCode || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              label="Intermediary Code"
              name="intermediaryCode"
              value={
                formData?.policy_sticker_creation_metadata?.data?.intermediaryCode || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              label="Currency Code"
              name="currencyCode"
              value={
                formData?.policy_sticker_creation_metadata?.data?.currencyCode || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              label="Fleet Size"
              name="fleetSize"
              value={
                formData?.policy_sticker_creation_metadata?.data?.fleetSize || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              label="Gross Premium"
              name="grossPremium"
              value={
                formData?.policy_sticker_creation_metadata?.data?.grossPremium || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              label="Policy Notes"
              name="notes"
              value={
                formData?.policy_sticker_creation_metadata?.data?.notes || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              type="date"
              label="Policy Start Date"
              name="startDate"
              value={
                formData?.policy_sticker_creation_metadata?.data?.startDate || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              type="date"
              label="Policy Expiry Date"
              name="expiryDate"
              value={
                formData?.policy_sticker_creation_metadata?.data?.expiryDate || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              type="date"
              label="Transaction Date"
              name="transactionDate"
              value={
                formData?.policy_sticker_creation_metadata?.data?.transactionDate || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              type="date"
              label="Payment Date"
              name="paymentDate"
              value={
                formData?.policy_sticker_creation_metadata?.data?.paymentDate || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              label="Payment Mode"
              name="paymentMode"
              value={
                formData?.policy_sticker_creation_metadata?.data?.paymentMode || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              label="Special Terms"
              name="specialTerms"
              value={
                formData?.policy_sticker_creation_metadata?.data?.specialTerms || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              label="Umbrella Limit"
              name="umbrellaLimit"
              value={
                formData?.policy_sticker_creation_metadata?.data?.umbrellaLimit || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

            <Input
              label="Company Policy Number"
              name="companyAssignedPolicyNumber"
              value={
                formData?.policy_sticker_creation_metadata?.data
                  ?.companyAssignedPolicyNumber || ""
              }
              onChange={(e) => handleChange(e, "root")}
            />

          </div>
        </div>


      </div>
      <div className="mt-5 mb-4 flex gap-4 items-end justify-end">
        <Button
          onClick={() => handleCreateSticker()}
          size="sm"
          className="capitalize flex items-center flex-row items-centerfont-normal"
          style={{
            background:
              colors?.length! > 1
                ? `${colors![0]?.toLowerCase()}`
                : `${DEFAULTPRIMARYCOLOR}`,
          }}
        >
          <BiPlus size={20} />
          {loading ? <Spinner className="w-4 h-4" /> : "Generate Sticker"}
        </Button>

        {/* <Button
                onClick={() => setShowModal(true)}
                size="sm"
                className="capitalize flex items-center flex-row items-centerfont-normal"
                style={{
                  background:
                    colors?.length! > 1
                      ? `${colors![0]?.toLowerCase()}`
                      : `${DEFAULTPRIMARYCOLOR}`,
                }}
              >
                <BiPlus size={20} />
                {loading ? <Spinner className="w-4 h-4" /> : "Add Sticker Number"}
              </Button> */}
      </div>
    </>
  )
}

export default PolicyDetail
